import React,{useEffect, useRef} from 'react'
import { useState } from 'react'


import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../../context/AppDataContext';
import ConfirmDialog from '../../../../../../components/ConfirmDialog';
import { Print } from '@mui/icons-material';
import DocumentTemplateForm from '../components/DocumentTemplateForm';
import documentTemplateServices from '../documentTemplateServices';
import { useAlert } from '../../../../../../context/AlertContext';
import CRMLayout from '../../../../../../layout/components/CRMLayout';




const CellActions = (props) =>{
    return(
        <>
            <DocumentTemplateForm  callBack={props.callBack} data={props.data} />
            <ConfirmDialog id={props.data.id} confirm={ ()=>props.remove(props.data.id)} >Are you Sure You want to remove</ConfirmDialog>
        </>
    )
  }


function DocumentTemplateListPage() {

  const {getMasterLabel} = useAppData()
  const [documentTemplateList,setDocumentTemplateList] = useState(null)
  const {AppAlert} = useAlert();

  const getDocumentTemplateList = () =>{
    documentTemplateServices.getList().then(res=>{
      setDocumentTemplateList(res.data);
    }).catch(error=>{

    })
  }


  const gridRef = useRef();
  

  const remove = (id) =>{
    documentTemplateServices.remove(id).then(res=>{
      AppAlert("Template Removed Successfully");
      getDocumentTemplateList();
    }).catch(error=>{

    })
  }

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},
        {field:"title",headerName: "Title",width:250},
        
        
        {headerName:"Action", width:"200", valueGetter: params => params.data.title,
            cellRenderer: CellActions,
            cellRendererParams: {
                callBack:getDocumentTemplateList,
                remove:remove
            },
        },      
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);

  const documentTemplateCallBack = () =>{
    getDocumentTemplateList();
  }
  return (
    <CRMLayout>
      <div className='row'>
        <div className='col-md-6'><h4>Documents</h4></div>
        <div className='col-md-6'> 
          <span className='float-end'><DocumentTemplateForm callBack={documentTemplateCallBack} /></span>
        </div>
        <div className='col-md-12 mt-2'>
          <div className="ag-theme-alpine" style={{height: 400}}>
              <AgGridReact
                ref={gridRef}
                rowData={documentTemplateList}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                onGridReady={getDocumentTemplateList}
              />
            </div>
          </div>
        </div>
    </CRMLayout>
    
  )
}

export default DocumentTemplateListPage